import { render, staticRenderFns } from "./PortfolioApp.vue?vue&type=template&id=4de83f0c&"
import script from "./PortfolioApp.vue?vue&type=script&lang=js&"
export * from "./PortfolioApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports